import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

// Custom language detector to check user's country
const customDetector = {
  name: 'customDetector',
  lookup(options) {
    // Check if user has previously selected a language
    const storedLang = localStorage.getItem('i18nextLng');
    if (storedLang) {
      return storedLang;
    }

    // Default to English for non-Azerbaijan users
    // This will be updated by the geolocation check
    return 'en';
  },
  cacheUserLanguage(lng) {
    localStorage.setItem('i18nextLng', lng);
  }
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(customDetector);

i18n
  .use(HttpApi)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'az',
    supportedLngs: ['az'],
    detection: {
      order: ['localStorage', 'customDetector', 'navigator'],
      caches: ['localStorage'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Detect user location and set language
fetch('https://ipapi.co/json/')
  .then(response => response.json())
  .then(data => {
    const storedLang = localStorage.getItem('i18nextLng');
    // Only set language if user hasn't manually selected one
    if (!storedLang) {
      // If user is from Azerbaijan, use Azerbaijani, otherwise English
      const language = data.country_code === 'AZ' ? 'az' : 'en';
      i18n.changeLanguage(language);
    }
  })
  .catch(error => {
    console.log('Could not detect location, defaulting to English');
    // Default to English if geolocation fails
    const storedLang = localStorage.getItem('i18nextLng');
    if (!storedLang) {
      i18n.changeLanguage('en');
    }
  });

export default i18n;
